export default __webpack_public_path__ + "static/media/bp_bonus.647395fe.svg";